import url from 'url';

export default (imageUrl) => {
  if (!imageUrl) return null;

  const parsed = url.parse(imageUrl);
  const path = parsed.path;
  const hostname = parsed.hostname;

  if (hostname?.includes('aroma-zone') && path?.substr(0, 6) === '/media') {
    return path;
  }

  if (hostname?.includes('ctfassets.net')) {
    return 'cf' + path;
  } else if (path?.includes('ctfassets.net')) {
    return 'cf' + path.substr(22);
  }

  if (hostname?.includes('rackcdn.com')) {
    return 'ct' + path;
  }

  if (hostname?.includes('commercetools.com')) {
    return 'ctcdn' + path;
  }

  return imageUrl;
};
